import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation AddRecordResponsiblePersons(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $spaceRecordId: ID!
    $employeeIds: [ID!]!
    $primaryResponsiblePersonId: ID
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                addResponsiblePersons(
                  spaceRecordId: $spaceRecordId
                  employeeIds: $employeeIds
                  primaryResponsiblePersonId: $primaryResponsiblePersonId
                )
              }
            }
          }
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.AddRecordResponsiblePersonsMutation,
  undefined,
  graphql.schema.AddRecordResponsiblePersonsMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
